import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { getBackendUrl } from "../config";

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!password || password.length < 8) {
      setError("Le mot de passe doit comporter au moins 8 caractères.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Les mots de passe ne correspondent pas.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${getBackendUrl()}/api/auth/password-reset/confirm`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, new_password: password }),
      });
      const data = await res.json();
      setLoading(false);

      if (res.ok && data.status === "success") {
        setSuccess(true);
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setError(data.message || "Le lien de réinitialisation est expiré ou invalide.");
      }
    } catch (err) {
      setLoading(false);
      setError("Erreur de connexion au serveur.");
    }
  };

  return (
    <div style={{
      display: "flex", justifyContent: "center", alignItems: "center",
      minHeight: "80vh", padding: "20px", fontFamily: "Inter, system-ui, sans-serif"
    }}>
      <div style={{
        background: "rgba(10, 10, 15, 0.85)", backdropFilter: "blur(10px)",
        borderRadius: "16px", border: "1px solid rgba(255, 255, 255, 0.1)",
        maxWidth: "420px", width: "100%", padding: "40px", color: "#fff",
        boxShadow: "0 20px 50px rgba(0,0,0,0.6)"
      }}>
        <h2 style={{ textAlign: "center", color: "#00f0ff", marginTop: 0, marginBottom: "10px" }}>
          🔑 Réinitialisation d'Accès
        </h2>
        <p style={{ textAlign: "center", color: "#aaa", fontSize: "0.88rem", marginBottom: "30px" }}>
          Définissez le nouveau mot de passe de votre identité centrale.
        </p>

        {!token && (
          <div style={{ background: "rgba(255,50,50,0.15)", border: "1px solid #ff3232", borderRadius: "8px", padding: "15px", color: "#ff8888", fontSize: "0.9rem" }}>
            ⚠️ Aucun jeton de réinitialisation fourni. Veuillez utiliser le lien reçu par email ou refaire une demande.
            <div style={{ marginTop: "15px", textAlign: "center" }}>
              <Link to="/login" style={{ color: "#00f0ff", textDecoration: "none" }}>← Retour à la connexion</Link>
            </div>
          </div>
        )}

        {token && !success && (
          <form onSubmit={handleSubmit}>
            {error && (
              <div style={{ background: "rgba(255,50,50,0.15)", border: "1px solid #ff3232", borderRadius: "8px", padding: "10px", color: "#ff8888", fontSize: "0.85rem", marginBottom: "15px" }}>
                {error}
              </div>
            )}

            <div style={{ marginBottom: "15px" }}>
              <label style={{ display: "block", fontSize: "0.85rem", color: "#ccc", marginBottom: "6px" }}>
                Nouveau mot de passe (8+ car.)
              </label>
              <input
                type="password"
                required
                minLength={8}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={{
                  width: "100%", padding: "12px", background: "#1A1C29", border: "1px solid #33374A",
                  borderRadius: "8px", color: "#fff", fontSize: "0.95rem", boxSizing: "border-box"
                }}
              />
            </div>

            <div style={{ marginBottom: "25px" }}>
              <label style={{ display: "block", fontSize: "0.85rem", color: "#ccc", marginBottom: "6px" }}>
                Confirmer le mot de passe
              </label>
              <input
                type="password"
                required
                minLength={8}
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={{
                  width: "100%", padding: "12px", background: "#1A1C29", border: "1px solid #33374A",
                  borderRadius: "8px", color: "#fff", fontSize: "0.95rem", boxSizing: "border-box"
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                width: "100%", padding: "14px", background: "linear-gradient(135deg, #00f0ff, #7000ff)",
                border: "none", borderRadius: "8px", color: "#fff", fontWeight: "bold", fontSize: "1rem",
                cursor: "pointer", opacity: loading ? 0.6 : 1
              }}
            >
              {loading ? "Mise à jour..." : "Enregistrer le mot de passe"}
            </button>
          </form>
        )}

        {success && (
          <div style={{ background: "rgba(0, 255, 148, 0.15)", border: "1px solid #00ff94", borderRadius: "8px", padding: "20px", textAlign: "center" }}>
            <div style={{ color: "#00ff94", fontSize: "1.1rem", fontWeight: "bold", marginBottom: "10px" }}>
              ✅ Mot de passe mis à jour !
            </div>
            <p style={{ color: "#ddd", fontSize: "0.9rem", margin: "0 0 15px 0" }}>
              Votre mot de passe a été modifié avec succès. Redirection vers la page de connexion...
            </p>
            <Link to="/login" style={{ color: "#00f0ff", fontWeight: "bold", textDecoration: "none" }}>
              Se connecter immédiatement →
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
